// Formats a booking's createdAt (ISO string) in the organization's timezone, so it can be
// cross-referenced with Stripe (which lists transactions by creation time).
// e.g. "Feb 2, 2026, 3:18 PM CST". Kept tiny + tasteful — not to be confused with the trip date.
export const formatCreatedAt = (iso) => {
  if (!iso) return null;
  const tz = localStorage.getItem('orgTimezone') || 'America/Chicago';
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      month: 'short', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit', hour12: true,
      timeZoneName: 'short',
    }).format(new Date(iso));
  } catch {
    return new Date(iso).toLocaleString();
  }
};

// GMB-sourced bookings are pulled from email, so "Created" really means "Imported".
export const isGmbBooking = (booking) => {
  const src = (booking?.source || '').toLowerCase();
  return src.includes('gmb') || src.includes('getmyboat')
    || !!booking?.sourceDetails?.gmb_reservation_id
    || !!booking?.source_details?.gmb_reservation_id;
};
export const createdLabel = (booking) => (isGmbBooking(booking) ? 'Imported' : 'Created');
